/**
 * Created by Languagenut on 18/04/2019.
 */


import React  from 'react';
import {ProgressBar , ListGroup , Table , Badge , Form , Button , Card , Row , Col , Nav} from 'react-bootstrap'
import ReactDOM from "react-dom";
import Constants from '../../../constants.js';
import {StudentsService} from '../../../services';
import {ImportStore} from '../../../store';
import Alert from '../../alert.js';
import FieldGroup from '../../FieldGroup.js'
import Checkbox from '../../checkbox.js';

class CreateSummary extends React.Component {

    constructor(props) {
        super();
        this.props = props;
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.setState({update:true});
    }

    renderUsernameAlert(){
        return <Alert icon="fa-exclamation"  variant={"warning"}>
            <table>
                <tr><td>You have conflicting usernames with exiting users in your school what would you like us todo ?</td>
                    <td style={{width:"200px"}}>
                        <Form.Group>
                            <Checkbox
                                style={{display:"block"}}
                                type="radio"
                                label="Skip these students"
                                name="formHorizontalRadios"
                                id="formHorizontalRadios1"
                                />
                            <Checkbox
                                style={{display:"block"}}
                                type="radio"
                                label="Generate new usernames"
                                name="formHorizontalRadios"
                                id="formHorizontalRadios2"
                                />
                        </Form.Group>
                    </td>
                </tr>
            </table>
        </Alert>
    }

    renderError(){
        return <Alert  variant={"danger"}>
            You have conflicting ID's these will not be created! if your wanting to update these student please use the student updater&nbsp;<small className="hyperlink">click here!</small>
        </Alert>
    }


    render(){
        let classesToMake = Number(this.props.results.classes.summary.to_create_total);
        let totalStudents = Number(this.props.results.students.summary.to_create_total);
        let totalUsernameConflictStudents = Number(this.props.results.students.summary.duplicate);
        let totaIDConflictStudents = Number(this.props.results.students.summary.make);


        let warning = null;
        let error   = null;
        if(totalUsernameConflictStudents > 0) warning = this.renderUsernameAlert.bind(this)();
        if(totaIDConflictStudents > 0) this.renderError.bind(this)();


        return <div style={{padding:"20px"}}>
            <Card.Title>Student Import  <small><i class="fas fa-chevron-right"></i></small>   Step 3: Import Summary</Card.Title>
            <b>Class Creation Summary</b>
            <br/>
            <br/>
            <Table size="sm"  bordered={false}  responsive>
                <tr><td>Classes to be Created&nbsp;<small className="hyperlink">download list</small></td><td style={{textAlign:"right"}}><b>{classesToMake}</b></td></tr>
            </Table>
            <br/>
            <Table size="sm"  bordered={false}  responsive>
                <tr><td>Total Students To Make&nbsp;<small className="hyperlink">download list</small></td><td style={{textAlign:"right"}}><b>{totaIDConflictStudents}</b></td></tr>
                <tr><td>Total Students To Move&nbsp;<small className="hyperlink">download list</small></td><td style={{textAlign:"right"}}><b>{totalUsernameConflictStudents}</b></td></tr>
            </Table>
        </div>
    }
}


class UploadStudentsComfirmation extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            errors:[],
            warnings:[],
            summary:[],
            loading:true
        };

        this.props.data.settings = {
            generateUsernames:false
        };
    }


    componentDidMount(){

        let csv    = this.props.data.csv || [];
        let fields = this.props.data.fields || {};

        StudentsService.test(fields , csv , this.props.data.headerRow);
    }

    componentWillReceiveProps(props){

    }

    componentWillMount(props){
        ImportStore.on(Constants.TEST_STUDENT_IMPORT , ()=>{
            this.setState({
               loading:false,
               results:ImportStore.getTestResults(),
            });

        });
    }


    handleFileChange(){

    }

    render(){

        if(this.state.loading) return <ProgressBar animated now={100} />


        return <CreateSummary results={this.state.results} />
    }


}


export default {
    name: "Summary",
    icon:<i class="fa-2x fas fa-file-alt"></i>,
    title:null,
    onSubmit: function (done){
        done();
    },
    component: UploadStudentsComfirmation
}